import React, { useState } from "react";
import ViewMore from "./ViewMore";
import NuAmount from "../../../../../Components/Utils/NuAmount";
import NuAmountPro from "../../../../../Components/Utils/NuAmountPro";
import NuNumber from "../../../../../Components/Utils/NuNumber";



const ExpandableBOQ = ({data,getData, Activity,Unit, titleId, selectedExpandedItems, onExpandedCheckboxChange,estimationId }) => {
    // const [data, setData] = useState([])
  return (
    <>
    {
        data.map((item, index) => (
            <tr className={`w-[100%] even:bg-white odd:bg-gray-50 text-xs font-normal text-[#4f4768]`} 
            // style={{borderBottom:'1px solid #c7dfe0'}}
             key={index}>
            <td className=" w-[5%] py-3 px-1">
                <div className=" w-full gap-1 flex">
                <input 
            type="checkbox" 
            checked={selectedExpandedItems[titleId]?.includes(item.id) || false}
            onChange={() => onExpandedCheckboxChange(titleId, item.id)}
            />
                {index+1}
                </div>
            </td>
            <td className=" w-[35%] py-3 px-1">{item?.item}</td>
            <td className=" w-[15%] py-3 px-1">{item?.unit}</td>
            <td className=" w-[10%] py-3 px-1">{item?.quantity}</td>
            <td className=" w-[15%] py-3 px-1 text-center"><NuNumber value={item?.unitPrice} /></td>
            <td className=" w-[15%] py-3 px-1 text-center"><NuNumber value={item?.totalPrice} /></td>
            <td className=" w-[5%] py-3 pl-3">
                         <ViewMore id={titleId || ""}
                            getData={getData}
                            data={item}
                            estimationId={estimationId}
                            Unit={Unit}
                            Activity={Activity}
                            /> 
            </td>
           </tr>
        ))
    }
    </>
  );
};

export default ExpandableBOQ;
